var Qe = Object.defineProperty, Ze = Object.defineProperties;
var Je = Object.getOwnPropertyDescriptors;
var z = Object.getOwnPropertySymbols;
var ae = Object.prototype.hasOwnProperty, ie = Object.prototype.propertyIsEnumerable;
var oe = Math.pow, te = (e, r, n) => r in e ? Qe(e, r, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[r] = n, c = (e, r) => {
  for (var n in r || (r = {}))
    ae.call(r, n) && te(e, n, r[n]);
  if (z)
    for (var n of z(r))
      ie.call(r, n) && te(e, n, r[n]);
  return e;
}, I = (e, r) => Ze(e, Je(r));
var _ = (e, r) => {
  var n = {};
  for (var t in e)
    ae.call(e, t) && r.indexOf(t) < 0 && (n[t] = e[t]);
  if (e != null && z)
    for (var t of z(e))
      r.indexOf(t) < 0 && ie.call(e, t) && (n[t] = e[t]);
  return n;
};
import { useContext as X, createContext as ye, useMemo as er, useId as rr, forwardRef as q } from "react";
import { jsx as R, jsxs as nr, Fragment as tr } from "react/jsx-runtime";
import { r as o } from "./rem-CMQJ_ZTp.js";
function K(e) {
  return Object.keys(e);
}
function W(e) {
  return e && typeof e == "object" && !Array.isArray(e);
}
function ge(e, r) {
  const n = c({}, e), t = r;
  return W(e) && W(r) && Object.keys(r).forEach((i) => {
    W(t[i]) && i in e ? n[i] = ge(n[i], t[i]) : n[i] = t[i];
  }), n;
}
function ar(e) {
  return e.replace(/[A-Z]/g, (r) => `-${r.toLowerCase()}`);
}
function Q(e) {
  return Object.keys(e).reduce((r, n) => (e[n] !== void 0 && (r[n] = e[n]), r), {});
}
function ir(e) {
  if (typeof e == "number")
    return !0;
  if (typeof e == "string") {
    if (e.startsWith("calc(") || e.startsWith("var(") || e.includes(" ") && e.trim() !== "")
      return !0;
    const r = /^[+-]?[0-9]+(\.[0-9]+)?(px|em|rem|ex|ch|lh|rlh|vw|vh|vmin|vmax|vb|vi|svw|svh|lvw|lvh|dvw|dvh|cm|mm|in|pt|pc|q|cqw|cqh|cqi|cqb|cqmin|cqmax|%)?$/;
    return e.trim().split(/\s+/).every((t) => r.test(t));
  }
  return !1;
}
function hn(e) {
  return e;
}
function be(e) {
  var r, n, t = "";
  if (typeof e == "string" || typeof e == "number") t += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (r = 0; r < i; r++) e[r] && (n = be(e[r])) && (t && (t += " "), t += n);
  } else for (n in e) e[n] && (t && (t += " "), t += n);
  return t;
}
function L() {
  for (var e, r, n = 0, t = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (r = be(e)) && (t && (t += " "), t += r);
  return t;
}
const or = {};
function sr(e) {
  const r = {};
  return e.forEach((n) => {
    Object.entries(n).forEach(([t, i]) => {
      r[t] ? r[t] = L(r[t], i) : r[t] = i;
    });
  }), r;
}
function Z({ theme: e, classNames: r, props: n, stylesCtx: t }) {
  const a = (Array.isArray(r) ? r : [r]).map(
    (s) => typeof s == "function" ? s(e, n, t) : s || or
  );
  return sr(a);
}
function G({ theme: e, styles: r, props: n, stylesCtx: t }) {
  return (Array.isArray(r) ? r : [r]).reduce((a, s) => typeof s == "function" ? c(c({}, a), s(e, n, t)) : c(c({}, a), s), {});
}
const fr = ye(null);
function C() {
  const e = X(fr);
  if (!e)
    throw new Error("[@mantine/core] MantineProvider was not found in tree");
  return e;
}
function $n() {
  return C().cssVariablesResolver;
}
function cr() {
  return C().classNamesPrefix;
}
function lr() {
  return C().getStyleNonce;
}
function dr() {
  return C().withStaticClasses;
}
function ur() {
  return C().headless;
}
function pr() {
  var e;
  return (e = C().stylesTransform) == null ? void 0 : e.sx;
}
function mr() {
  var e;
  return (e = C().stylesTransform) == null ? void 0 : e.styles;
}
function yr(e) {
  return /^#?([0-9A-F]{3}){1,2}([0-9A-F]{2})?$/i.test(e);
}
function gr(e) {
  let r = e.replace("#", "");
  if (r.length === 3) {
    const s = r.split("");
    r = [
      s[0],
      s[0],
      s[1],
      s[1],
      s[2],
      s[2]
    ].join("");
  }
  if (r.length === 8) {
    const s = parseInt(r.slice(6, 8), 16) / 255;
    return {
      r: parseInt(r.slice(0, 2), 16),
      g: parseInt(r.slice(2, 4), 16),
      b: parseInt(r.slice(4, 6), 16),
      a: s
    };
  }
  const n = parseInt(r, 16), t = n >> 16 & 255, i = n >> 8 & 255, a = n & 255;
  return {
    r: t,
    g: i,
    b: a,
    a: 1
  };
}
function br(e) {
  const [r, n, t, i] = e.replace(/[^0-9,./]/g, "").split(/[/,]/).map(Number);
  return { r, g: n, b: t, a: i || 1 };
}
function hr(e) {
  const r = /^hsla?\(\s*(\d+)\s*,\s*(\d+%)\s*,\s*(\d+%)\s*(,\s*(0?\.\d+|\d+(\.\d+)?))?\s*\)$/i, n = e.match(r);
  if (!n)
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 1
    };
  const t = parseInt(n[1], 10), i = parseInt(n[2], 10) / 100, a = parseInt(n[3], 10) / 100, s = n[5] ? parseFloat(n[5]) : void 0, f = (1 - Math.abs(2 * a - 1)) * i, l = t / 60, d = f * (1 - Math.abs(l % 2 - 1)), p = a - f / 2;
  let u, m, y;
  return l >= 0 && l < 1 ? (u = f, m = d, y = 0) : l >= 1 && l < 2 ? (u = d, m = f, y = 0) : l >= 2 && l < 3 ? (u = 0, m = f, y = d) : l >= 3 && l < 4 ? (u = 0, m = d, y = f) : l >= 4 && l < 5 ? (u = d, m = 0, y = f) : (u = f, m = 0, y = d), {
    r: Math.round((u + p) * 255),
    g: Math.round((m + p) * 255),
    b: Math.round((y + p) * 255),
    a: s || 1
  };
}
function J(e) {
  return yr(e) ? gr(e) : e.startsWith("rgb") ? br(e) : e.startsWith("hsl") ? hr(e) : {
    r: 0,
    g: 0,
    b: 0,
    a: 1
  };
}
function j(e, r) {
  if (e.startsWith("var("))
    return `color-mix(in srgb, ${e}, black ${r * 100}%)`;
  const { r: n, g: t, b: i, a } = J(e), s = 1 - r, f = (l) => Math.round(l * s);
  return `rgba(${f(n)}, ${f(t)}, ${f(i)}, ${a})`;
}
function $r(e, r) {
  return typeof e.primaryShade == "number" ? e.primaryShade : r === "dark" ? e.primaryShade.dark : e.primaryShade.light;
}
function O(e) {
  return e <= 0.03928 ? e / 12.92 : oe((e + 0.055) / 1.055, 2.4);
}
function vr(e) {
  const r = e.match(/oklch\((.*?)%\s/);
  return r ? parseFloat(r[1]) : null;
}
function Sr(e) {
  if (e.startsWith("oklch("))
    return (vr(e) || 0) / 100;
  const { r, g: n, b: t } = J(e), i = r / 255, a = n / 255, s = t / 255, f = O(i), l = O(a), d = O(s);
  return 0.2126 * f + 0.7152 * l + 0.0722 * d;
}
function M(e, r = 0.179) {
  return e.startsWith("var(") ? !1 : Sr(e) > r;
}
function F({
  color: e,
  theme: r,
  colorScheme: n
}) {
  if (typeof e != "string")
    throw new Error(
      `[@mantine/core] Failed to parse color. Expected color to be a string, instead got ${typeof e}`
    );
  if (e === "bright")
    return {
      color: e,
      value: n === "dark" ? r.white : r.black,
      shade: void 0,
      isThemeColor: !1,
      isLight: M(
        n === "dark" ? r.white : r.black,
        r.luminanceThreshold
      ),
      variable: "--mantine-color-bright"
    };
  if (e === "dimmed")
    return {
      color: e,
      value: n === "dark" ? r.colors.dark[2] : r.colors.gray[7],
      shade: void 0,
      isThemeColor: !1,
      isLight: M(
        n === "dark" ? r.colors.dark[2] : r.colors.gray[6],
        r.luminanceThreshold
      ),
      variable: "--mantine-color-dimmed"
    };
  if (e === "white" || e === "black")
    return {
      color: e,
      value: e === "white" ? r.white : r.black,
      shade: void 0,
      isThemeColor: !1,
      isLight: M(
        e === "white" ? r.white : r.black,
        r.luminanceThreshold
      ),
      variable: `--mantine-color-${e}`
    };
  const [t, i] = e.split("."), a = i ? Number(i) : void 0, s = t in r.colors;
  if (s) {
    const f = a !== void 0 ? r.colors[t][a] : r.colors[t][$r(r, n || "light")];
    return {
      color: t,
      value: f,
      shade: a,
      isThemeColor: s,
      isLight: M(f, r.luminanceThreshold),
      variable: i ? `--mantine-color-${t}-${a}` : `--mantine-color-${t}-filled`
    };
  }
  return {
    color: e,
    value: e,
    isThemeColor: s,
    isLight: M(e, r.luminanceThreshold),
    shade: a,
    variable: void 0
  };
}
function se(e, r) {
  const n = F({ color: e || r.primaryColor, theme: r });
  return n.variable ? `var(${n.variable})` : e;
}
function fe(e, r) {
  const n = {
    from: (e == null ? void 0 : e.from) || r.defaultGradient.from,
    to: (e == null ? void 0 : e.to) || r.defaultGradient.to,
    deg: (e == null ? void 0 : e.deg) || r.defaultGradient.deg || 0
  }, t = se(n.from, r), i = se(n.to, r);
  return `linear-gradient(${n.deg}deg, ${t} 0%, ${i} 100%)`;
}
function h(e, r) {
  if (typeof e != "string" || r > 1 || r < 0)
    return "rgba(0, 0, 0, 1)";
  if (e.startsWith("var(")) {
    const a = (1 - r) * 100;
    return `color-mix(in srgb, ${e}, transparent ${a}%)`;
  }
  if (e.startsWith("oklch"))
    return e.includes("/") ? e.replace(/\/\s*[\d.]+\s*\)/, `/ ${r})`) : e.replace(")", ` / ${r})`);
  const { r: n, g: t, b: i } = J(e);
  return `rgba(${n}, ${t}, ${i}, ${r})`;
}
const vn = h, Cr = ({
  color: e,
  theme: r,
  variant: n,
  gradient: t,
  autoContrast: i
}) => {
  const a = F({ color: e, theme: r }), s = typeof i == "boolean" ? i : r.autoContrast;
  if (n === "filled") {
    const f = s && a.isLight ? "var(--mantine-color-black)" : "var(--mantine-color-white)";
    return a.isThemeColor ? a.shade === void 0 ? {
      background: `var(--mantine-color-${e}-filled)`,
      hover: `var(--mantine-color-${e}-filled-hover)`,
      color: f,
      border: `${o(1)} solid transparent`
    } : {
      background: `var(--mantine-color-${a.color}-${a.shade})`,
      hover: `var(--mantine-color-${a.color}-${a.shade === 9 ? 8 : a.shade + 1})`,
      color: f,
      border: `${o(1)} solid transparent`
    } : {
      background: e,
      hover: j(e, 0.1),
      color: f,
      border: `${o(1)} solid transparent`
    };
  }
  if (n === "light") {
    if (a.isThemeColor) {
      if (a.shade === void 0)
        return {
          background: `var(--mantine-color-${e}-light)`,
          hover: `var(--mantine-color-${e}-light-hover)`,
          color: `var(--mantine-color-${e}-light-color)`,
          border: `${o(1)} solid transparent`
        };
      const f = r.colors[a.color][a.shade];
      return {
        background: h(f, 0.1),
        hover: h(f, 0.12),
        color: `var(--mantine-color-${a.color}-${Math.min(a.shade, 6)})`,
        border: `${o(1)} solid transparent`
      };
    }
    return {
      background: h(e, 0.1),
      hover: h(e, 0.12),
      color: e,
      border: `${o(1)} solid transparent`
    };
  }
  if (n === "outline")
    return a.isThemeColor ? a.shade === void 0 ? {
      background: "transparent",
      hover: `var(--mantine-color-${e}-outline-hover)`,
      color: `var(--mantine-color-${e}-outline)`,
      border: `${o(1)} solid var(--mantine-color-${e}-outline)`
    } : {
      background: "transparent",
      hover: h(r.colors[a.color][a.shade], 0.05),
      color: `var(--mantine-color-${a.color}-${a.shade})`,
      border: `${o(1)} solid var(--mantine-color-${a.color}-${a.shade})`
    } : {
      background: "transparent",
      hover: h(e, 0.05),
      color: e,
      border: `${o(1)} solid ${e}`
    };
  if (n === "subtle") {
    if (a.isThemeColor) {
      if (a.shade === void 0)
        return {
          background: "transparent",
          hover: `var(--mantine-color-${e}-light-hover)`,
          color: `var(--mantine-color-${e}-light-color)`,
          border: `${o(1)} solid transparent`
        };
      const f = r.colors[a.color][a.shade];
      return {
        background: "transparent",
        hover: h(f, 0.12),
        color: `var(--mantine-color-${a.color}-${Math.min(a.shade, 6)})`,
        border: `${o(1)} solid transparent`
      };
    }
    return {
      background: "transparent",
      hover: h(e, 0.12),
      color: e,
      border: `${o(1)} solid transparent`
    };
  }
  return n === "transparent" ? a.isThemeColor ? a.shade === void 0 ? {
    background: "transparent",
    hover: "transparent",
    color: `var(--mantine-color-${e}-light-color)`,
    border: `${o(1)} solid transparent`
  } : {
    background: "transparent",
    hover: "transparent",
    color: `var(--mantine-color-${a.color}-${Math.min(a.shade, 6)})`,
    border: `${o(1)} solid transparent`
  } : {
    background: "transparent",
    hover: "transparent",
    color: e,
    border: `${o(1)} solid transparent`
  } : n === "white" ? a.isThemeColor ? a.shade === void 0 ? {
    background: "var(--mantine-color-white)",
    hover: j(r.white, 0.01),
    color: `var(--mantine-color-${e}-filled)`,
    border: `${o(1)} solid transparent`
  } : {
    background: "var(--mantine-color-white)",
    hover: j(r.white, 0.01),
    color: `var(--mantine-color-${a.color}-${a.shade})`,
    border: `${o(1)} solid transparent`
  } : {
    background: "var(--mantine-color-white)",
    hover: j(r.white, 0.01),
    color: e,
    border: `${o(1)} solid transparent`
  } : n === "gradient" ? {
    background: fe(t, r),
    hover: fe(t, r),
    color: "var(--mantine-color-white)",
    border: "none"
  } : n === "default" ? {
    background: "var(--mantine-color-default)",
    hover: "var(--mantine-color-default-hover)",
    color: "var(--mantine-color-default-color)",
    border: `${o(1)} solid var(--mantine-color-default-border)`
  } : {};
}, xr = {
  dark: [
    "#C9C9C9",
    "#b8b8b8",
    "#828282",
    "#696969",
    "#424242",
    "#3b3b3b",
    "#2e2e2e",
    "#242424",
    "#1f1f1f",
    "#141414"
  ],
  gray: [
    "#f8f9fa",
    "#f1f3f5",
    "#e9ecef",
    "#dee2e6",
    "#ced4da",
    "#adb5bd",
    "#868e96",
    "#495057",
    "#343a40",
    "#212529"
  ],
  red: [
    "#fff5f5",
    "#ffe3e3",
    "#ffc9c9",
    "#ffa8a8",
    "#ff8787",
    "#ff6b6b",
    "#fa5252",
    "#f03e3e",
    "#e03131",
    "#c92a2a"
  ],
  pink: [
    "#fff0f6",
    "#ffdeeb",
    "#fcc2d7",
    "#faa2c1",
    "#f783ac",
    "#f06595",
    "#e64980",
    "#d6336c",
    "#c2255c",
    "#a61e4d"
  ],
  grape: [
    "#f8f0fc",
    "#f3d9fa",
    "#eebefa",
    "#e599f7",
    "#da77f2",
    "#cc5de8",
    "#be4bdb",
    "#ae3ec9",
    "#9c36b5",
    "#862e9c"
  ],
  violet: [
    "#f3f0ff",
    "#e5dbff",
    "#d0bfff",
    "#b197fc",
    "#9775fa",
    "#845ef7",
    "#7950f2",
    "#7048e8",
    "#6741d9",
    "#5f3dc4"
  ],
  indigo: [
    "#edf2ff",
    "#dbe4ff",
    "#bac8ff",
    "#91a7ff",
    "#748ffc",
    "#5c7cfa",
    "#4c6ef5",
    "#4263eb",
    "#3b5bdb",
    "#364fc7"
  ],
  blue: [
    "#e7f5ff",
    "#d0ebff",
    "#a5d8ff",
    "#74c0fc",
    "#4dabf7",
    "#339af0",
    "#228be6",
    "#1c7ed6",
    "#1971c2",
    "#1864ab"
  ],
  cyan: [
    "#e3fafc",
    "#c5f6fa",
    "#99e9f2",
    "#66d9e8",
    "#3bc9db",
    "#22b8cf",
    "#15aabf",
    "#1098ad",
    "#0c8599",
    "#0b7285"
  ],
  teal: [
    "#e6fcf5",
    "#c3fae8",
    "#96f2d7",
    "#63e6be",
    "#38d9a9",
    "#20c997",
    "#12b886",
    "#0ca678",
    "#099268",
    "#087f5b"
  ],
  green: [
    "#ebfbee",
    "#d3f9d8",
    "#b2f2bb",
    "#8ce99a",
    "#69db7c",
    "#51cf66",
    "#40c057",
    "#37b24d",
    "#2f9e44",
    "#2b8a3e"
  ],
  lime: [
    "#f4fce3",
    "#e9fac8",
    "#d8f5a2",
    "#c0eb75",
    "#a9e34b",
    "#94d82d",
    "#82c91e",
    "#74b816",
    "#66a80f",
    "#5c940d"
  ],
  yellow: [
    "#fff9db",
    "#fff3bf",
    "#ffec99",
    "#ffe066",
    "#ffd43b",
    "#fcc419",
    "#fab005",
    "#f59f00",
    "#f08c00",
    "#e67700"
  ],
  orange: [
    "#fff4e6",
    "#ffe8cc",
    "#ffd8a8",
    "#ffc078",
    "#ffa94d",
    "#ff922b",
    "#fd7e14",
    "#f76707",
    "#e8590c",
    "#d9480f"
  ]
}, ce = "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji", he = {
  scale: 1,
  fontSmoothing: !0,
  focusRing: "auto",
  white: "#fff",
  black: "#000",
  colors: xr,
  primaryShade: { light: 6, dark: 8 },
  primaryColor: "blue",
  variantColorResolver: Cr,
  autoContrast: !1,
  luminanceThreshold: 0.3,
  fontFamily: ce,
  fontFamilyMonospace: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace",
  respectReducedMotion: !1,
  cursorType: "default",
  defaultGradient: { from: "blue", to: "cyan", deg: 45 },
  defaultRadius: "sm",
  activeClassName: "mantine-active",
  focusClassName: "",
  headings: {
    fontFamily: ce,
    fontWeight: "700",
    textWrap: "wrap",
    sizes: {
      h1: { fontSize: o(34), lineHeight: "1.3" },
      h2: { fontSize: o(26), lineHeight: "1.35" },
      h3: { fontSize: o(22), lineHeight: "1.4" },
      h4: { fontSize: o(18), lineHeight: "1.45" },
      h5: { fontSize: o(16), lineHeight: "1.5" },
      h6: { fontSize: o(14), lineHeight: "1.5" }
    }
  },
  fontSizes: {
    xs: o(12),
    sm: o(14),
    md: o(16),
    lg: o(18),
    xl: o(20)
  },
  lineHeights: {
    xs: "1.4",
    sm: "1.45",
    md: "1.55",
    lg: "1.6",
    xl: "1.65"
  },
  radius: {
    xs: o(2),
    sm: o(4),
    md: o(8),
    lg: o(16),
    xl: o(32)
  },
  spacing: {
    xs: o(10),
    sm: o(12),
    md: o(16),
    lg: o(20),
    xl: o(32)
  },
  breakpoints: {
    xs: "36em",
    sm: "48em",
    md: "62em",
    lg: "75em",
    xl: "88em"
  },
  shadows: {
    xs: `0 ${o(1)} ${o(3)} rgba(0, 0, 0, 0.05), 0 ${o(1)} ${o(2)} rgba(0, 0, 0, 0.1)`,
    sm: `0 ${o(1)} ${o(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${o(10)} ${o(
      15
    )} ${o(-5)}, rgba(0, 0, 0, 0.04) 0 ${o(7)} ${o(7)} ${o(-5)}`,
    md: `0 ${o(1)} ${o(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${o(20)} ${o(
      25
    )} ${o(-5)}, rgba(0, 0, 0, 0.04) 0 ${o(10)} ${o(10)} ${o(-5)}`,
    lg: `0 ${o(1)} ${o(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${o(28)} ${o(
      23
    )} ${o(-7)}, rgba(0, 0, 0, 0.04) 0 ${o(12)} ${o(12)} ${o(-7)}`,
    xl: `0 ${o(1)} ${o(3)} rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05) 0 ${o(36)} ${o(
      28
    )} ${o(-7)}, rgba(0, 0, 0, 0.04) 0 ${o(17)} ${o(17)} ${o(-7)}`
  },
  other: {},
  components: {}
}, wr = "[@mantine/core] MantineProvider: Invalid theme.primaryColor, it accepts only key of theme.colors, learn more – https://mantine.dev/theming/colors/#primary-color", le = "[@mantine/core] MantineProvider: Invalid theme.primaryShade, it accepts only 0-9 integers or an object { light: 0-9, dark: 0-9 }";
function B(e) {
  return e < 0 || e > 9 ? !1 : parseInt(e.toString(), 10) === e;
}
function de(e) {
  if (!(e.primaryColor in e.colors))
    throw new Error(wr);
  if (typeof e.primaryShade == "object" && (!B(e.primaryShade.dark) || !B(e.primaryShade.light)))
    throw new Error(le);
  if (typeof e.primaryShade == "number" && !B(e.primaryShade))
    throw new Error(le);
}
function kr(e, r) {
  var t;
  if (!r)
    return de(e), e;
  const n = ge(e, r);
  return r.fontFamily && !((t = r.headings) != null && t.fontFamily) && (n.headings.fontFamily = r.fontFamily), de(n), n;
}
const ee = ye(null), Tr = () => X(ee) || he;
function H() {
  const e = X(ee);
  if (!e)
    throw new Error(
      "@mantine/core: MantineProvider was not found in component tree, make sure you have it in your app"
    );
  return e;
}
function Mr({
  theme: e,
  children: r,
  inherit: n = !0
}) {
  const t = Tr(), i = er(
    () => kr(n ? t : he, e),
    [e, t, n]
  );
  return /* @__PURE__ */ R(ee.Provider, { value: i, children: r });
}
Mr.displayName = "@mantine/core/MantineThemeProvider";
const Rr = {
  always: "mantine-focus-always",
  auto: "mantine-focus-auto",
  never: "mantine-focus-never"
};
function Nr({ theme: e, options: r, unstyled: n }) {
  return L(
    (r == null ? void 0 : r.focusable) && !n && (e.focusClassName || Rr[e.focusRing]),
    (r == null ? void 0 : r.active) && !n && e.activeClassName
  );
}
function Ar({
  selector: e,
  stylesCtx: r,
  options: n,
  props: t,
  theme: i
}) {
  return Z({
    theme: i,
    classNames: n == null ? void 0 : n.classNames,
    props: (n == null ? void 0 : n.props) || t,
    stylesCtx: r
  })[e];
}
function ue({
  selector: e,
  stylesCtx: r,
  theme: n,
  classNames: t,
  props: i
}) {
  return Z({ theme: n, classNames: t, props: i, stylesCtx: r })[e];
}
function Er({ rootSelector: e, selector: r, className: n }) {
  return e === r ? n : void 0;
}
function zr({ selector: e, classes: r, unstyled: n }) {
  return n ? void 0 : r[e];
}
function Ir({
  themeName: e,
  classNamesPrefix: r,
  selector: n,
  withStaticClass: t
}) {
  return t === !1 ? [] : e.map((i) => `${r}-${i}-${n}`);
}
function _r({
  themeName: e,
  theme: r,
  selector: n,
  props: t,
  stylesCtx: i
}) {
  return e.map(
    (a) => {
      var s, f;
      return (f = Z({
        theme: r,
        classNames: (s = r.components[a]) == null ? void 0 : s.classNames,
        props: t,
        stylesCtx: i
      })) == null ? void 0 : f[n];
    }
  );
}
function jr({
  options: e,
  classes: r,
  selector: n,
  unstyled: t
}) {
  return e != null && e.variant && !t ? r[`${n}--${e.variant}`] : void 0;
}
function Lr({
  theme: e,
  options: r,
  themeName: n,
  selector: t,
  classNamesPrefix: i,
  classNames: a,
  classes: s,
  unstyled: f,
  className: l,
  rootSelector: d,
  props: p,
  stylesCtx: u,
  withStaticClasses: m,
  headless: y,
  transformedStyles: v
}) {
  return L(
    Nr({ theme: e, options: r, unstyled: f || y }),
    _r({ theme: e, themeName: n, selector: t, props: p, stylesCtx: u }),
    jr({ options: r, classes: s, selector: t, unstyled: f }),
    ue({ selector: t, stylesCtx: u, theme: e, classNames: a, props: p }),
    ue({ selector: t, stylesCtx: u, theme: e, classNames: v, props: p }),
    Ar({ selector: t, stylesCtx: u, options: r, props: p, theme: e }),
    Er({ rootSelector: d, selector: t, className: l }),
    zr({ selector: t, classes: s, unstyled: f || y }),
    m && !y && Ir({
      themeName: n,
      classNamesPrefix: i,
      selector: t,
      withStaticClass: r == null ? void 0 : r.withStaticClass
    }),
    r == null ? void 0 : r.className
  );
}
function Fr({
  theme: e,
  themeName: r,
  props: n,
  stylesCtx: t,
  selector: i
}) {
  return r.map(
    (a) => {
      var s;
      return G({
        theme: e,
        styles: (s = e.components[a]) == null ? void 0 : s.styles,
        props: n,
        stylesCtx: t
      })[i];
    }
  ).reduce((a, s) => c(c({}, a), s), {});
}
function U({ style: e, theme: r }) {
  return Array.isArray(e) ? [...e].reduce(
    (n, t) => c(c({}, n), U({ style: t, theme: r })),
    {}
  ) : typeof e == "function" ? e(r) : e == null ? {} : e;
}
function Hr(e) {
  return e.reduce((r, n) => (n && Object.keys(n).forEach((t) => {
    r[t] = c(c({}, r[t]), Q(n[t]));
  }), r), {});
}
function Pr({
  vars: e,
  varsResolver: r,
  theme: n,
  props: t,
  stylesCtx: i,
  selector: a,
  themeName: s,
  headless: f
}) {
  var l;
  return (l = Hr([
    f ? {} : r == null ? void 0 : r(n, t, i),
    ...s.map((d) => {
      var p, u, m;
      return (m = (u = (p = n.components) == null ? void 0 : p[d]) == null ? void 0 : u.vars) == null ? void 0 : m.call(u, n, t, i);
    }),
    e == null ? void 0 : e(n, t, i)
  ])) == null ? void 0 : l[a];
}
function Wr({
  theme: e,
  themeName: r,
  selector: n,
  options: t,
  props: i,
  stylesCtx: a,
  rootSelector: s,
  styles: f,
  style: l,
  vars: d,
  varsResolver: p,
  headless: u,
  withStylesTransform: m
}) {
  return c(c(c(c(c(c({}, !m && Fr({ theme: e, themeName: r, props: i, stylesCtx: a, selector: n })), !m && G({ theme: e, styles: f, props: i, stylesCtx: a })[n]), !m && G({ theme: e, styles: t == null ? void 0 : t.styles, props: (t == null ? void 0 : t.props) || i, stylesCtx: a })[n]), Pr({ theme: e, props: i, stylesCtx: a, vars: d, varsResolver: p, selector: n, themeName: r, headless: u })), s === n ? U({ style: l, theme: e }) : null), U({ style: t == null ? void 0 : t.style, theme: e }));
}
function Or({ props: e, stylesCtx: r, themeName: n }) {
  var s;
  const t = H(), i = (s = mr()) == null ? void 0 : s();
  return {
    getTransformedStyles: (f) => i ? [
      ...f.map(
        (d) => i(d, { props: e, theme: t, ctx: r })
      ),
      ...n.map(
        (d) => {
          var p;
          return i((p = t.components[d]) == null ? void 0 : p.styles, { props: e, theme: t, ctx: r });
        }
      )
    ].filter(Boolean) : [],
    withStylesTransform: !!i
  };
}
function Sn({
  name: e,
  classes: r,
  props: n,
  stylesCtx: t,
  className: i,
  style: a,
  rootSelector: s = "root",
  unstyled: f,
  classNames: l,
  styles: d,
  vars: p,
  varsResolver: u
}) {
  const m = H(), y = cr(), v = dr(), w = ur(), $ = (Array.isArray(e) ? e : [e]).filter((g) => g), { withStylesTransform: x, getTransformedStyles: k } = Or({
    props: n,
    stylesCtx: t,
    themeName: $
  });
  return (g, b) => ({
    className: Lr({
      theme: m,
      options: b,
      themeName: $,
      selector: g,
      classNamesPrefix: y,
      classNames: l,
      classes: r,
      unstyled: f,
      className: i,
      rootSelector: s,
      props: n,
      stylesCtx: t,
      withStaticClasses: v,
      headless: w,
      transformedStyles: k([b == null ? void 0 : b.styles, d])
    }),
    style: Wr({
      theme: m,
      themeName: $,
      selector: g,
      options: b,
      props: n,
      stylesCtx: t,
      rootSelector: s,
      styles: d,
      style: a,
      vars: p,
      varsResolver: u,
      headless: w,
      withStylesTransform: x
    })
  });
}
function Cn(e, r, n) {
  var s;
  const t = H(), i = (s = t.components[e]) == null ? void 0 : s.defaultProps, a = typeof i == "function" ? i(t) : i;
  return c(c(c({}, r), a), Q(n));
}
function V(e) {
  return K(e).reduce(
    (r, n) => e[n] !== void 0 ? `${r}${ar(n)}:${e[n]};` : r,
    ""
  ).trim();
}
function Br({ selector: e, styles: r, media: n, container: t }) {
  const i = r ? V(r) : "", a = Array.isArray(n) ? n.map((f) => `@media${f.query}{${e}{${V(f.styles)}}}`) : [], s = Array.isArray(t) ? t.map(
    (f) => `@container ${f.query}{${e}{${V(f.styles)}}}`
  ) : [];
  return `${i ? `${e}{${i}}` : ""}${a.join("")}${s.join("")}`.trim();
}
function Vr(e) {
  const r = lr();
  return /* @__PURE__ */ R(
    "style",
    {
      "data-mantine-styles": "inline",
      nonce: r == null ? void 0 : r(),
      dangerouslySetInnerHTML: { __html: Br(e) }
    }
  );
}
function Dr(e) {
  const ne = e, {
    m: r,
    mx: n,
    my: t,
    mt: i,
    mb: a,
    ml: s,
    mr: f,
    me: l,
    ms: d,
    p,
    px: u,
    py: m,
    pt: y,
    pb: v,
    pl: w,
    pr: $,
    pe: x,
    ps: k,
    bd: g,
    bg: b,
    c: T,
    opacity: P,
    ff: N,
    fz: S,
    fw: A,
    lts: E,
    ta: Ce,
    lh: xe,
    fs: we,
    tt: ke,
    td: Te,
    w: Me,
    miw: Re,
    maw: Ne,
    h: Ae,
    mih: Ee,
    mah: ze,
    bgsz: Ie,
    bgp: _e,
    bgr: je,
    bga: Le,
    pos: Fe,
    top: He,
    left: Pe,
    bottom: We,
    right: Oe,
    inset: Be,
    display: Ve,
    flex: De,
    hiddenFrom: qe,
    visibleFrom: Ge,
    lightHidden: Ue,
    darkHidden: Ye,
    sx: Xe
  } = ne, Ke = _(ne, [
    "m",
    "mx",
    "my",
    "mt",
    "mb",
    "ml",
    "mr",
    "me",
    "ms",
    "p",
    "px",
    "py",
    "pt",
    "pb",
    "pl",
    "pr",
    "pe",
    "ps",
    "bd",
    "bg",
    "c",
    "opacity",
    "ff",
    "fz",
    "fw",
    "lts",
    "ta",
    "lh",
    "fs",
    "tt",
    "td",
    "w",
    "miw",
    "maw",
    "h",
    "mih",
    "mah",
    "bgsz",
    "bgp",
    "bgr",
    "bga",
    "pos",
    "top",
    "left",
    "bottom",
    "right",
    "inset",
    "display",
    "flex",
    "hiddenFrom",
    "visibleFrom",
    "lightHidden",
    "darkHidden",
    "sx"
  ]);
  return { styleProps: Q({
    m: r,
    mx: n,
    my: t,
    mt: i,
    mb: a,
    ml: s,
    mr: f,
    me: l,
    ms: d,
    p,
    px: u,
    py: m,
    pt: y,
    pb: v,
    pl: w,
    pr: $,
    pe: x,
    ps: k,
    bd: g,
    bg: b,
    c: T,
    opacity: P,
    ff: N,
    fz: S,
    fw: A,
    lts: E,
    ta: Ce,
    lh: xe,
    fs: we,
    tt: ke,
    td: Te,
    w: Me,
    miw: Re,
    maw: Ne,
    h: Ae,
    mih: Ee,
    mah: ze,
    bgsz: Ie,
    bgp: _e,
    bgr: je,
    bga: Le,
    pos: Fe,
    top: He,
    left: Pe,
    bottom: We,
    right: Oe,
    inset: Be,
    display: Ve,
    flex: De,
    hiddenFrom: qe,
    visibleFrom: Ge,
    lightHidden: Ue,
    darkHidden: Ye,
    sx: Xe
  }), rest: Ke };
}
const qr = {
  m: { type: "spacing", property: "margin" },
  mt: { type: "spacing", property: "marginTop" },
  mb: { type: "spacing", property: "marginBottom" },
  ml: { type: "spacing", property: "marginLeft" },
  mr: { type: "spacing", property: "marginRight" },
  ms: { type: "spacing", property: "marginInlineStart" },
  me: { type: "spacing", property: "marginInlineEnd" },
  mx: { type: "spacing", property: "marginInline" },
  my: { type: "spacing", property: "marginBlock" },
  p: { type: "spacing", property: "padding" },
  pt: { type: "spacing", property: "paddingTop" },
  pb: { type: "spacing", property: "paddingBottom" },
  pl: { type: "spacing", property: "paddingLeft" },
  pr: { type: "spacing", property: "paddingRight" },
  ps: { type: "spacing", property: "paddingInlineStart" },
  pe: { type: "spacing", property: "paddingInlineEnd" },
  px: { type: "spacing", property: "paddingInline" },
  py: { type: "spacing", property: "paddingBlock" },
  bd: { type: "border", property: "border" },
  bg: { type: "color", property: "background" },
  c: { type: "textColor", property: "color" },
  opacity: { type: "identity", property: "opacity" },
  ff: { type: "fontFamily", property: "fontFamily" },
  fz: { type: "fontSize", property: "fontSize" },
  fw: { type: "identity", property: "fontWeight" },
  lts: { type: "size", property: "letterSpacing" },
  ta: { type: "identity", property: "textAlign" },
  lh: { type: "lineHeight", property: "lineHeight" },
  fs: { type: "identity", property: "fontStyle" },
  tt: { type: "identity", property: "textTransform" },
  td: { type: "identity", property: "textDecoration" },
  w: { type: "spacing", property: "width" },
  miw: { type: "spacing", property: "minWidth" },
  maw: { type: "spacing", property: "maxWidth" },
  h: { type: "spacing", property: "height" },
  mih: { type: "spacing", property: "minHeight" },
  mah: { type: "spacing", property: "maxHeight" },
  bgsz: { type: "size", property: "backgroundSize" },
  bgp: { type: "identity", property: "backgroundPosition" },
  bgr: { type: "identity", property: "backgroundRepeat" },
  bga: { type: "identity", property: "backgroundAttachment" },
  pos: { type: "identity", property: "position" },
  top: { type: "size", property: "top" },
  left: { type: "size", property: "left" },
  bottom: { type: "size", property: "bottom" },
  right: { type: "size", property: "right" },
  inset: { type: "size", property: "inset" },
  display: { type: "identity", property: "display" },
  flex: { type: "identity", property: "flex" }
};
function re(e, r) {
  const n = F({ color: e, theme: r });
  return n.color === "dimmed" ? "var(--mantine-color-dimmed)" : n.color === "bright" ? "var(--mantine-color-bright)" : n.variable ? `var(${n.variable})` : n.color;
}
function Gr(e, r) {
  const n = F({ color: e, theme: r });
  return n.isThemeColor && n.shade === void 0 ? `var(--mantine-color-${n.color}-text)` : re(e, r);
}
function Ur(e, r) {
  if (typeof e == "number")
    return o(e);
  if (typeof e == "string") {
    const [n, t, ...i] = e.split(" ").filter((s) => s.trim() !== "");
    let a = `${o(n)}`;
    return t && (a += ` ${t}`), i.length > 0 && (a += ` ${re(i.join(" "), r)}`), a.trim();
  }
  return e;
}
const pe = {
  text: "var(--mantine-font-family)",
  mono: "var(--mantine-font-family-monospace)",
  monospace: "var(--mantine-font-family-monospace)",
  heading: "var(--mantine-font-family-headings)",
  headings: "var(--mantine-font-family-headings)"
};
function Yr(e) {
  return typeof e == "string" && e in pe ? pe[e] : e;
}
const Xr = ["h1", "h2", "h3", "h4", "h5", "h6"];
function Kr(e, r) {
  return typeof e == "string" && e in r.fontSizes ? `var(--mantine-font-size-${e})` : typeof e == "string" && Xr.includes(e) ? `var(--mantine-${e}-font-size)` : typeof e == "number" ? o(e) : typeof e == "string" ? o(e) : e;
}
function Qr(e) {
  return e;
}
const Zr = ["h1", "h2", "h3", "h4", "h5", "h6"];
function Jr(e, r) {
  return typeof e == "string" && e in r.lineHeights ? `var(--mantine-line-height-${e})` : typeof e == "string" && Zr.includes(e) ? `var(--mantine-${e}-line-height)` : e;
}
function en(e) {
  return typeof e == "number" ? o(e) : e;
}
function rn(e, r) {
  if (typeof e == "number")
    return o(e);
  if (typeof e == "string") {
    const n = e.replace("-", "");
    if (!(n in r.spacing))
      return o(e);
    const t = `--mantine-spacing-${n}`;
    return e.startsWith("-") ? `calc(var(${t}) * -1)` : `var(${t})`;
  }
  return e;
}
const D = {
  color: re,
  textColor: Gr,
  fontSize: Kr,
  spacing: rn,
  identity: Qr,
  size: en,
  lineHeight: Jr,
  fontFamily: Yr,
  border: Ur
};
function me(e) {
  return e.replace("(min-width: ", "").replace("em)", "");
}
function nn(n) {
  var t = n, {
    media: e
  } = t, r = _(t, [
    "media"
  ]);
  const a = Object.keys(e).sort((s, f) => Number(me(s)) - Number(me(f))).map((s) => ({ query: s, styles: e[s] }));
  return I(c({}, r), { media: a });
}
function tn(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const r = Object.keys(e);
  return !(r.length === 1 && r[0] === "base");
}
function an(e) {
  return typeof e == "object" && e !== null ? "base" in e ? e.base : void 0 : e;
}
function on(e) {
  return typeof e == "object" && e !== null ? K(e).filter((r) => r !== "base") : [];
}
function sn(e, r) {
  return typeof e == "object" && e !== null && r in e ? e[r] : e;
}
function fn({
  styleProps: e,
  data: r,
  theme: n
}) {
  return nn(
    K(e).reduce(
      (t, i) => {
        if (i === "hiddenFrom" || i === "visibleFrom" || i === "sx")
          return t;
        const a = r[i], s = Array.isArray(a.property) ? a.property : [a.property], f = an(e[i]);
        if (!tn(e[i]))
          return s.forEach((d) => {
            t.inlineStyles[d] = D[a.type](f, n);
          }), t;
        t.hasResponsiveStyles = !0;
        const l = on(e[i]);
        return s.forEach((d) => {
          f && (t.styles[d] = D[a.type](f, n)), l.forEach((p) => {
            const u = `(min-width: ${n.breakpoints[p]})`;
            t.media[u] = I(c({}, t.media[u]), {
              [d]: D[a.type](
                sn(e[i], p),
                n
              )
            });
          });
        }), t;
      },
      {
        hasResponsiveStyles: !1,
        styles: {},
        inlineStyles: {},
        media: {}
      }
    )
  );
}
function cn() {
  return `__m__-${rr().replace(/:/g, "")}`;
}
function xn(e) {
  return e;
}
function $e(e) {
  return e.startsWith("data-") ? e : `data-${e}`;
}
function ln(e) {
  return Object.keys(e).reduce((r, n) => {
    const t = e[n];
    return t === void 0 || t === "" || t === !1 || t === null || (r[$e(n)] = e[n]), r;
  }, {});
}
function ve(e) {
  return e ? typeof e == "string" ? { [$e(e)]: !0 } : Array.isArray(e) ? [...e].reduce(
    (r, n) => c(c({}, r), ve(n)),
    {}
  ) : ln(e) : null;
}
function Y(e, r) {
  return Array.isArray(e) ? [...e].reduce(
    (n, t) => c(c({}, n), Y(t, r)),
    {}
  ) : typeof e == "function" ? e(r) : e == null ? {} : e;
}
function dn({
  theme: e,
  style: r,
  vars: n,
  styleProps: t
}) {
  const i = Y(r, e), a = Y(n, e);
  return c(c(c({}, i), a), t);
}
const Se = q(
  (w, v) => {
    var $ = w, {
      component: e,
      style: r,
      __vars: n,
      className: t,
      variant: i,
      mod: a,
      size: s,
      hiddenFrom: f,
      visibleFrom: l,
      lightHidden: d,
      darkHidden: p,
      renderRoot: u,
      __size: m
    } = $, y = _($, [
      "component",
      "style",
      "__vars",
      "className",
      "variant",
      "mod",
      "size",
      "hiddenFrom",
      "visibleFrom",
      "lightHidden",
      "darkHidden",
      "renderRoot",
      "__size"
    ]);
    var E;
    const x = H(), k = e || "div", { styleProps: g, rest: b } = Dr(y), T = pr(), P = (E = T == null ? void 0 : T()) == null ? void 0 : E(g.sx), N = cn(), S = fn({
      styleProps: g,
      theme: x,
      data: qr
    }), A = c(c({
      ref: v,
      style: dn({
        theme: x,
        style: r,
        vars: n,
        styleProps: S.inlineStyles
      }),
      className: L(t, P, {
        [N]: S.hasResponsiveStyles,
        "mantine-light-hidden": d,
        "mantine-dark-hidden": p,
        [`mantine-hidden-from-${f}`]: f,
        [`mantine-visible-from-${l}`]: l
      }),
      "data-variant": i,
      "data-size": ir(s) ? void 0 : s || void 0,
      size: m
    }, ve(a)), b);
    return /* @__PURE__ */ nr(tr, { children: [
      S.hasResponsiveStyles && /* @__PURE__ */ R(
        Vr,
        {
          selector: `.${N}`,
          styles: S.styles,
          media: S.media
        }
      ),
      typeof u == "function" ? u(A) : /* @__PURE__ */ R(k, c({}, A))
    ] });
  }
);
Se.displayName = "@mantine/core/Box";
const wn = Se;
function un(e) {
  return e;
}
function kn(e) {
  const r = q(e);
  return r.extend = un, r.withProps = (n) => {
    const t = q((i, a) => /* @__PURE__ */ R(r, I(c(c({}, n), i), { ref: a })));
    return t.extend = r.extend, t.displayName = `WithProps(${r.displayName})`, t;
  }, r;
}
export {
  wn as B,
  he as D,
  Vr as I,
  fr as M,
  Z as a,
  ir as b,
  L as c,
  xn as d,
  Cn as e,
  kn as f,
  Sn as g,
  hn as h,
  un as i,
  Dr as j,
  $r as k,
  se as l,
  fe as m,
  cn as n,
  fn as o,
  F as p,
  Q as q,
  G as r,
  h as s,
  lr as t,
  H as u,
  K as v,
  vn as w,
  ge as x,
  $n as y,
  Mr as z
};
